import { Button, Dropdown } from "react-bootstrap";
import "./orderingproductprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import duplicateicon from "../../assets/images/duplicate-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import { ReactSVG } from "react-svg";
import { OrderingProduct } from "../../redux/orderingProduct/OPSlice";
import { MouseEventHandler } from "react";
import { useModulePermissions, PermissionIdentifier, PermissionModule } from "../../utils/permissionUtils";

interface OPProfileHeader {
  selectedOPData: OrderingProduct;
  updateStatus: any;
  toggleModal: MouseEventHandler<HTMLElement>;
  toggleDuplicateModal: MouseEventHandler<HTMLElement>;
}

const OrderingProductProfileHeader = ({
  selectedOPData,
  updateStatus,
  toggleModal,
  toggleDuplicateModal,
}: OPProfileHeader) => {

  const isPermitted = useModulePermissions(PermissionModule.ORDERING_PRODUCT_MASTER);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_ORDERING_PRODUCT_MASTER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_ORDERING_PRODUCT_MASTER);
  const isDuplicatePermitted = isPermitted(PermissionIdentifier.DUPLICATE_ORDERING_PRODUCT_MASTER);
  const isStatusChangePermitted = isPermitted(PermissionIdentifier.INACTIVE_ORDERING_PRODUCT_MASTER);

  return (
    <div className="ordering-product-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{selectedOPData.productDescription}</h2>
        <div
          className={`status-box 
          ${selectedOPData?.isActive ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          {selectedOPData?.isActive ? "Active" : "Inactive"}
        </div>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href="/edit-ordering-product">
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        {(isStatusChangePermitted || isDeletePermitted || isDuplicatePermitted) && (
          <Dropdown>
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {isStatusChangePermitted && (
                <Dropdown.Item onClick={() => updateStatus()}>
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={deactivateicon}
                  />
                  {selectedOPData.isActive ? "Deactivate" : "Activate"}
                </Dropdown.Item>
              )}
              {isDeletePermitted && (
                <Dropdown.Item onClick={toggleModal}>
                  <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                  Delete
                </Dropdown.Item>
              )}
              {isDuplicatePermitted && (
                <Dropdown.Item onClick={toggleDuplicateModal}>
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={duplicateicon}
                  />
                  Duplicate
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
  );
};

export default OrderingProductProfileHeader;
